import type {
  Dataset,
  DatasetCreateVariables,
  DatasetUpdateVariables,
} from "./dataset.type";
import type { UseCreateOptions, UseUpdateOptions } from "@/hooks/queries";
import type { Int } from "@/types";

import { useCreate, useUpdate } from "@/hooks/queries";

export const useDatasetObservationCreate = (
  observationId: Int,
  options?: UseCreateOptions
) => {
  return useCreate<Dataset, DatasetCreateVariables>("observations.datasets", {
    ...options,
    rootId: observationId,
  });
};

export const useDatasetUpdate = (
  datasetId: number,
  options?: UseUpdateOptions
) => {
  return useUpdate<Dataset, DatasetUpdateVariables>(
    "datasets",
    datasetId,
    options
  );
};
